export default "__VITE_ASSET__B6dJgB_U__"